import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useI18n, useSelector } from '~Hooks';
import { useButton } from '~Hooks';
import { useTableApi } from '~Components/TableUniverse';
import { handyBreakpoint } from '~Styles/breakpoints';
import { useStorage } from '~Components/Storage';

const ServiceChargeWrapper = styled.div`
  padding: 16px 16px 10px;
  color: var(--colorWhite);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;

  ${handyBreakpoint} {
    padding: 12px 16px 10px;
  }
`;

const RemoveButton = styled.div`
  border: 1px solid var(--colorBlueGray800);
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
`;

interface Props {
  chequeId: string;
  percentage: number;
  disableTouchAction?: boolean; // Used in parked orders to prevent modification of the order when its parked
}

/**
 * This component is used to display a Service Charge item with a delete button in the bottom of the cart for tables
 * The reason we do this is to enable a way for the user to remove a service charge from a cheque.
 */

const ServiceCharge: FC<Props> = ({ chequeId, percentage, disableTouchAction }) => {
  const { i18n } = useI18n();
  const tableApi = useTableApi();

  const removeServiceChargeButton = useButton({
    onClick: () => tableApi.removeServiceCharge(chequeId),
  });

  return (
    <div>
      <ServiceChargeWrapper>
        <span>{`${i18n('ServiceCharge.Title')} ${percentage}%`}</span>
        {!disableTouchAction && (
          <RemoveButton {...removeServiceChargeButton}>{i18n('Settings.Remove')}</RemoveButton>
        )}
      </ServiceChargeWrapper>
    </div>
  );
};

export default ServiceCharge;
